import React, { PureComponent } from "react";

import { Icon } from "../../components";

import style from "./Section.module.scss";
import { Link } from "react-router-dom";

class SectionServices extends PureComponent {
  constructor(props) {
    super(props);
    this.lessthanthree = this.lessthanthree.bind(this);
  }

  lessthanthree(_el, i, len) {
    const { locale } = this.props;
    const imageUrl = _el.image && (_el.image.file_url || _el.image);

    if (i < 3) {
      return (
        <Link to={`/${locale}/service-details/${_el.slug}`} key={_el.id || i}>
          <div
            className={`${style.services} ${
              i + 1 === 2 && style[`services--mid`]
            } ${i + 1 === len && style[`services--last`]}`}
          >
            <div className={`${style[`services--inner`]}`}>
              <img src={imageUrl} className={style.services__image} />
              <div className={`${style[`service__image--overlay`]}`} />
              <div
                className={`${style.services__info} ${
                  i + 1 === len ? style[`services__info--last`] : null
                }`}
              >
                <div className={`${style[`services__info--inner`]}`}>
                  <Icon type="plus" className={style.services__icon} />
                  <h4 className={style.services__title}>{_el.title}</h4>
                </div>
              </div>
            </div>
          </div>
        </Link>
      );
    }
  }

  render() {
    const { data, services: servicesProp } = this.props;
    // Prefer Strapi-mapped list from parent (Home); fall back to fixture shape.
    const services = (servicesProp && servicesProp.length)
      ? servicesProp
      : (data && data.services) || [];
    const len = Math.min(services.length, 3);
    return (
      <section className={style.services__section}>
        {services.map((_el, i) => this.lessthanthree(_el, i, len))}
      </section>
    );
  }
}

export default SectionServices;
